import styled from "styled-components"
import { Descripition, Headline } from "../../../utils"

export const MultipleSector = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 20px;
  width: 100%;
  scroll-margin-top: 96px;
  height: 100vh;
  background: ${(props) => props.theme.bgSectorColor};
  /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */

  /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */

  @media (max-width: 1290px) {
    height: auto;
    padding: 30px 30px;
    width: 100%;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    gap: 40px;
    width: 100%;
    background: ${(props) => props.theme.bgSectorColor};
  }
`

export const StickyViewport = styled.div`
  width: 100%;
  height: 100vh;

  @media only screen and (max-width: 768px) {
    position: static;
    height: auto;
    max-height: none;
    overflow: visible;
    display: block;
  }

  @media only screen and (min-width: 769px) {
    position: sticky;
    top: 106px;
    height: calc(100vh - 106px);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const ScrollTrack = styled.div`
  width: 100%;
  background: ${(props) => props.theme.bgSectorColor};
  position: relative;

  @media only screen and (max-width: 768px) {
    height: auto;
    min-height: 0;
  }

  @media only screen and (min-width: 769px) {
    min-height: 400vh;
    height: 400vh;
  }
`

export const MultipleSectorContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  max-width: 1212px;
  width: 100%;

  @media (max-width: 1290px) {
    padding: 60px 20px;
    width: 100%;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0px;
    width: 100%;
  }
`
export const MultipleSectorHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;
  padding-right: 70px;
  justify-content: center;

  @media (max-width: 768px) {
    text-align: center;
    width: 100%;
    height: auto;
    max-width: 335px;
    padding-right: 0px;
    padding-bottom: 50px;
  }

  @media only screen and (min-width: 769px) and (max-width: 1290px) {
    width: auto;
    height: auto;
  }

  p {
    ${(props) => props.theme.typography.sectionHeadline};
    font-family: Montserrat, sans-serif;
    font-size: 30px;
    color: ${(props) => props.theme.sameBase};
    max-width: 622px;

    @media (max-width: 1050px) {
      height: auto;
      font-size: 1.375rem;
      line-height: 150%;
    }
  }
  .description {
    ${(props) => props.theme.typography.paragraph1};
    font-family: Lato, sans-serif;
    color: #ffffff99;
    line-height: 170%;
    max-width: 622px;
  }

  .text-gradient {
    ${(props) => props.theme.typography.sectionHeadline};
    ${(props) => props.theme.typography.TextLinearGradient};
    font-family: Montserrat, sans-serif;
    @media (max-width: 1050px) {
      font-size: 1.375rem;
      line-height: 150%;
    }
  }
`
export const LargeScreenSection = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin-top: 14px;
  align-items: stretch;
`

export const CardContent = styled.div<{ $active: boolean; $hover: boolean }>`
  border-radius: 10px;
  width: 200px;
  border: ${({ $active }) =>
    $active ? "1px solid transparent" : "1px solid #242938"};

  background: ${({ $active, $hover }) =>
    $active
      ? `linear-gradient(#141925, #141925) padding-box,
         linear-gradient(87.75deg, #0058ee 0%, rgba(54, 215, 183, 0.8) 100%) border-box`
      : $hover
      ? "#141D31"
      : "#141925"};
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 22px 12px;

  .content {
    ${(props) => props.theme.typography.cardTitle4};
    line-height: 170%;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff99;
    text-align: center;
    font-family: Lato, sans-serif;
  }

  &:hover .content {
    color: #ffffff;
  }
  .activeText {
    color: #ffffff;
  }
`
export const SectorCards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 50px;
  max-width: 480px;
  height: 486px;
  width: 100%;
  gap: 20px;
  margin-bottom: 10px;
  overflow-y: scroll;
  padding-right: 20px;
  scroll-snap-type: y mandatory;
  scroll-behavior: auto;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;

  @media (max-width: 768px) {
    font-size: 1.375rem;
    line-height: 150%;
    max-width: 335px;
    width: 100%;
    height: auto;
    margin-bottom: 0;
    padding-right: 0;
    padding-bottom: 2.5rem;
    overflow: visible;
    scroll-snap-type: none;
    gap: 24px;
  }

  @media (max-width: 340px) {
    height: auto;
  }

  @media only screen and (min-width: 857px) and (max-width: 1290px) {
    line-height: 150%;
    height: 450px;
    scroll-snap-type: y mandatory;
    padding: 0px 0px 50px 0px;
  }
  @media only screen and (min-width: 769px) and (max-width: 857px) {
    height: 490px;
  }

  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 5px;
    background: ${(props) => props.theme.scrollBarColor};

    @media only screen and (min-width: 320px) and (max-width: 768px) {
      display: none;
    }
  }

  ::-webkit-scrollbar-track {
    border-radius: 5px;
    background: ${(props) => props.theme.scrollBarColor};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: ${(props) => props.theme.scrollBarGradient};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const SectorSnapItem = styled.div`
  width: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;

  will-change: transform, opacity;
  transition: transform 0.6s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1), filter 0.6s ease;

  opacity: 0.4;
  transform: translateY(20px) scale(0.97);

  &[data-state="active"] {
    opacity: 1;
    transform: translateY(0px) scale(1);
    filter: blur(0px);
  }

  &[data-state="near"] {
    opacity: 0.7;
    transform: translateY(10px) scale(0.985);
  }

  &[data-state="far"] {
    opacity: 0.35;
    transform: translateY(24px) scale(0.96);
    filter: blur(0.3px);
  }
`
export const SectorCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  max-width: 480px;
  height: 485px;

  border-radius: 50px;
  background: ${(props) => props.theme.bgSectorColor};

  scroll-snap-align: start;

  @media (max-width: 768px) {
    width: 100%;
    height: 419.5px;
    scroll-snap-align: unset;
  }
`
export const SectorContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  max-width: 509px;
  @media (max-width: 768px) {
    padding: 44px;
    width: 100%;
  }
`

export const SectorIcon = styled.div`
  img {
    max-width: 167.75px;
    max-height: 126px;
  }
`
export const SectorDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  max-width: 498px;

  @media only screen and (min-width: 769px) and (max-width: 1290px) {
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    padding-top: 30px;
  }
`

export const SectorTitle = styled.div`
  max-width: 493px;
  ${(props) => props.theme.typography.cardTitle};
  font-family: Montserrat, sans-serif;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  color: ${(props) => props.theme.textColor};
  padding-top: 32px;

  @media only screen and (min-width: 320px) and (max-width: 377px) {
    font-size: 1.125rem !important;
  }

  @media only screen and (min-width: 377px) and (max-width: 768px) {
    font-size: 1.25rem !important;
  }

  @media (max-width: 768px) {
    padding-top: 0px;
  }
`

export const SectorDescription = styled.div`
  max-width: 450px;
  ${(props) => props.theme.typography.descriptionMsg};
  text-align: center;
  color: ${(props) => props.theme.whiteAlpha60};
  padding-top: 12px;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0%;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100% !important;
    max-width: 245px;
    font-size: 0.875rem;
  }
`
export const HeadlineText = styled(Headline)`
  margin-bottom: 0px;
  text-align: start;
`

export const DescripitionText = styled(Descripition)`
  margin-bottom: 0px;
  text-align: start;
`
